export default __webpack_public_path__ + "static/media/qr_sticker_template.d6078896.png";